// src/Components/LoadingSpinner/LoadingSpinner.jsx
import React from 'react';
import '../LoadingSpinner/LoadingSpinner.css';
import PropTypes from 'prop-types';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="spinner-overlay">
      <div className="spinner-container"></div>
      {message && <p className="spinner-message">{message}</p>}
    </div>
  );
};

LoadingSpinner.propTypes = {
  message: PropTypes.string,
};

export default LoadingSpinner;